<template>
  <auth>
    <div class="col-md-6">
      <div class="auth">
        <div
          id="main-content"
          class="login-header"
        >
          <h4>Validate Account</h4>
          <hr>
          <div v-html="$error.handle(error)" />
          <form @submit.prevent="submit">
            <div class="form-group">
              <label>Enter the OTP sent to your number</label>
              <input
                v-model="code"
                v-validate="'required|numeric|length:6'"
                name="code"
                type="text"
                class="form-control"
                required
              >
              <div
                v-if="errors.has('code')"
                class="text-danger"
              >
                {{ errors.first("code") }}
              </div>
            </div>
            <div class="form-group d-flex align-items-center">
              <button
                v-if="loading"
                class="btn btn-warning"
              >
                Sending <i class="fa fa-spinner spin" />
              </button>
              <button
                v-else
                class="btn btn-success"
                type="submit"
                :disabled="errors.has('code')"
              >
                Confirm <i class="fa fa-check-circle" />
              </button>
              <button
                v-if="timerEnabled"
                class="btn btn-warning ml-3"
                disabled
              >
                Retry after {{ timerCount }} seconds
                <i class="fa fa-spinner spin" />
              </button>
              <button
                v-else
                class="btn btn-primary ml-3"
                type="button"
                @click.prevent="resendOtp"
              >
                <template v-if="attempt === 0">
                  Send Otp
                </template>
                <template v-else>
                  Resend Otp
                </template>
                <i class="fa fa-send-o" />
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </auth>
</template>

<script>
import Auth from "@/components/Auth.vue";
import { navigateLogin } from "@/mixins/auth";
import { mapGetters } from "vuex";

export default {
  components: {
    Auth,
  },
  data() {
    return {
      email: this.$route.params.email,
      attempt: 0,
      code: "",
      loading: false,
      error: "",
      timerEnabled: false,
      timerCount: 120,
    };
  },
  computed: {
    ...mapGetters({
      user: "getAuthUser",
      hasOtp: "getOtp",
    }),
  },
  watch: {
    timerEnabled(value) {
      if (value) {
        setTimeout(() => {
          this.timerCount--;
        }, 1000);
      }
    },
    timerCount: {
      handler(value) {
        if (value > 0 && this.timerEnabled) {
          setTimeout(() => {
            this.timerCount--;
          }, 1000);
        } else {
          this.timerEnabled = false;
        }
      },
      immediate: true, // This ensures the watcher is triggered upon creation
    },
  },
  mounted() {
    this.$nextTick(() => {
      this.timerEnabled = this.hasOtp;
    });
  },
  methods: {
    submit() {
      this.loading = true;
      if (!this.user.password) this.$router.replace("/login");
      this.$axios
        .post("/api/v1/otp/auth", {
          email: this.user.email,
          password: this.user.password,
          code: this.code,
        })
        .then((res) => {
          this.$toastr.s("Account verified!");
          navigateLogin(this, res.data);
        })
        .catch((error) => {
          if (error.response) {
            this.error = error.response;
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },
    resendOtp() {
      this.attempt++;
      this.timerEnabled = true;
      this.timerCount = 120;
      this.$axios
        .post("/api/v1/otp/resend", { email: this.user.email })
        .then((res) => {
          this.$toastr.s(res.data.message);
          this.error = "";
        })
        .catch((error) => {
          this.timerEnabled = false;
          if (error.response) {
            this.error = error.response;
          }
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.d-flex {
  display: flex !important;
}

.toast-success {
  background-color: green;
}

.btn {
  border-radius: 1.25rem;
  font-size: 1.12em;
  display: flex;
  justify-content: space-around;
  align-items: center;
  i{
    margin-left:4px
  }
}
</style>